/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import Dialog from 'components/Dialog.jsx';
import Link from 'components/Link.jsx';
import React from 'react';
import Glyph from 'components/Glyph.jsx';

import cx from 'classnames';
// TODO: referencing non-component stylesheet
import styles from './styles/JoinMergeAccountsModal.css';

class JoinMergeAccountsView extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    mergeAccount: React.PropTypes.func.isRequired,
    rejectAccount: React.PropTypes.func.isRequired,
  };

  render() {
    const { account } = this.props;

    const headerImage = (
      <Glyph
        className={cx(styles.headerImage)}
        name="mail"
        size="xxxlarge"
        color="brand"
      />
    );
    return (
      <Dialog
        eventScreenName="JoinMergeAccountsView"
        title={`Join ${account.organization_name} on Remind`}
        headerImageComponent={headerImage}
        size="xsmall"
        hideOnBlur={false}
        hideCloseButton
        onRequestHide={this.props.onRequestHide}
        subtext={
          `${account.from_admin_name} invited ${account.user_email} to join ` +
          `${account.organization_name} on Remind. We'll add this email ` +
          'address to your account.'
        }>
        <BoxBody>
          <Button
            full
            onClick={this.props.mergeAccount}
            className="submit JoinMergeAccountsModal-Button"
            eventElementName="submit JoinMergeAccountsModal-Button">
            Got it
          </Button>
          <Link
            className={cx('wrong_email', styles.rejectLink)}
            onClick={this.props.rejectAccount}
            color="thunder">
            Not your email address?
          </Link>
        </BoxBody>
      </Dialog>
    );
  }
}

export default JoinMergeAccountsView;



// WEBPACK FOOTER //
// ./src/join/components/JoinMergeAccountsView.jsx